// extracted by mini-css-extract-plugin
export default {"limitedWidth":"section_limitedWidth_tZ_1o","tab":"section_tab_V3ngw","tabLarge":"section_tabLarge_oNgP7","tabSmall":"section_tabSmall_I4wMa"};